import { withPreRenderSettings } from '@/utils/hocs';
import { NewAdView } from '@/views/Ads/NewAd.view';
import { getNewAdDefaultValues } from '@/api/helpers/ad.helpers';
import { NewAdDefaultValues } from '@/api/types/ads.types';
import NoSsr from '@/components/NoSsr/NoSsr';
import { getRegionsCached } from '@/api/helpers/regions.helpers';

interface Props {
  defaultValues: NewAdDefaultValues | null;
}

function NewAdPage({ defaultValues }: Props) {
  return (
    <NoSsr>
      <NewAdView {...defaultValues} />
    </NoSsr>
  );
}

NewAdPage.getInitialProps = withPreRenderSettings(async (context, client) => {
  const regionsData = await getRegionsCached(client, context);

  const defaultValues = await getNewAdDefaultValues(
    client,
    context,
    regionsData
  );

  return { defaultValues };
});

export default NewAdPage;
